export { default as VatReturnTable } from './vat-return-table';

export const vatFormLayout = context => [
  {
    stt: 'A',
    id: ['ct21', ''],
    description: context.$t('vat.form.A.label'),
    isCheckbox: true,
    editable: true,
    bolded: true,
  },
  {
    stt: 'B',
    id: ['', 'ct22'],
    description: context.$t('vat.form.B.label'),
    editable: true,
    bolded: true,
  },
  { stt: 'C', description: context.$t('vat.form.C.label'), bolded: true },
  { stt: 'I', description: context.$t('vat.form.C.I.label'), bolded: true },
  {
    stt: '1',
    id: ['ct23', 'ct24'],
    description: context.$t('vat.form.C.I.1.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  {
    stt: '',
    id: ['ct23a', 'ct24a'],
    description: context.$t('vat.form.C.I.1.a.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  {
    stt: '2',
    id: ['', 'ct25'],
    description: context.$t('vat.form.C.I.1.a.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  { stt: 'II', description: context.$t('vat.form.C.II.label'), bolded: true },
  {
    stt: '1',
    id: ['ct26', ''],
    description: context.$t('vat.form.C.II.1.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  {
    stt: '2',
    id: ['ct27', 'ct28'],
    description: context.$t('vat.form.C.II.2.label'),
    editable: false,
    bolded: true,
    dependsOn: {
      ct27: ['ct29', 'ct30', '+', 'ct32', '+', 'ct32a', '+'],
      ct28: ['ct31', 'ct33', '+'],
    },
  },
  {
    stt: 'a',
    id: ['ct29', ''],
    description: context.$t('vat.form.C.II.2.a.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  {
    stt: 'b',
    id: ['ct30', 'ct31'],
    description: context.$t('vat.form.C.II.2.b.label'),
    editable: ctx => ctx.data.ct21 === false,
    dependsOn: { ct31: ['ct30', '0.05', '*'] },
  },
  {
    stt: 'c',
    id: ['ct32', 'ct33'],
    description: context.$t('vat.form.C.II.2.c.label'),
    editable: ctx => ctx.data.ct21 === false,
    dependsOn: { ct33: ['ct32', '0.1', '*'] },
  },
  {
    stt: 'd',
    id: ['ct32a', ''],
    description: context.$t('vat.form.C.II.2.d.label'),
    editable: ctx => ctx.data.ct21 === false,
  },
  {
    stt: '3',
    id: ['ct34', 'ct35'],
    description: context.$t('vat.form.C.II.3.label'),
    editable: false,
    bolded: true,
    dependsOn: { ct34: ['ct26', 'ct27', '+'], ct35: ['ct28'] },
  },
  {
    stt: 'III',
    id: ['', 'ct36'],
    description: context.$t('vat.form.C.III.label'),
    editable: false,
    bolded: true,
    dependsOn: { ct36: ['ct35', 'ct25', '-'] },
  },
  { stt: 'IV', description: context.$t('vat.form.C.IV.label'), bolded: true },
  {
    stt: '1',
    id: ['', 'ct37'],
    description: context.$t('vat.form.C.IV.1.label'),
    editable: true,
  },
  {
    stt: '2',
    id: ['', 'ct38'],
    description: context.$t('vat.form.C.IV.2.label'),
    editable: true,
  },
  {
    stt: 'V',
    id: ['', 'ct39a'],
    description: context.$t('vat.form.C.V.label'),
    editable: true,
    bolded: true,
  },
  { stt: 'VI', description: context.$t('vat.form.C.VI.label'), bolded: true },
  {
    stt: '1',
    id: ['', 'ct40a'],
    description: context.$t('vat.form.C.VI.1.label'),
    editable: false,
    dependsOn: {
      ct40a: ['ct36', 'ct22', '-', 'ct37', '+', 'ct38', '-', 'ct39a', '-'],
    },
    show: {
      ct40a: [
        'ct36',
        'ct22',
        '-',
        'ct37',
        '+',
        'ct38',
        '-',
        'ct39a',
        '-',
        'DUP',
        '0',
        '>=',
        '0',
        'if',
      ],
    },
  },
  {
    stt: '2',
    id: ['', 'ct40b'],
    description: context.$t('vat.form.C.VI.2.label'),
    editable: true,
    operator: { ct40b: ['ct40b', 'ct40a', '<=', '1', '0', 'if'] },
  },
  {
    stt: '3',
    id: ['', 'ct40'],
    description: context.$t('vat.form.C.VI.3.label'),
    editable: false,
    dependsOn: { ct40: ['ct40a', 'ct40b', '-'] },
  },
  {
    stt: '4',
    id: ['', 'ct41'],
    description: context.$t('vat.form.C.VI.4.label'),
    editable: false,
    bolded: true,
    dependsOn: {
      ct41: ['ct36', 'ct22', '-', 'ct37', '+', 'ct38', '-', 'ct39a', '-'],
    },
    show: {
      ct41: [
        'ct36',
        'ct22',
        '-',
        'ct37',
        '+',
        'ct38',
        '-',
        'ct39a',
        '-',
        'DUP',
        '0',
        '<=',
        '0',
        'if',
      ],
    },
  },
  {
    stt: '4.1',
    id: ['', 'ct42'],
    description: context.$t('vat.form.C.VI.4.1.label'),
    editable: true,
    operator: { ct42: ['ct42', 'ct41', '<=', '1', '0', 'if'] },
  },
  {
    stt: '4.2',
    id: ['', 'ct43'],
    description: context.$t('vat.form.C.VI.4.2.label'),
    editable: false,
    // Nếu ct42 <= 0 thì ct43 = -ct42, ngược lại ct43 = 0
    dependsOn: { ct43: ['ct42', '0', '<=', 'ct42', 'NEG', '0', 'if'] },
  },
];

export const vatFormData = {
  ct21: false,
  ct22: 0,
  ct23: 0,
  ct23a: 0,
  ct24: 0,
  ct24a: 0,
  ct25: 0,
  ct26: 0,
  ct27: 0,
  ct28: 0,
  ct29: 0,
  ct30: 0,
  ct31: 0,
  ct32: 0,
  ct32a: 0,
  ct33: 0,
  ct34: 0,
  ct35: 0,
  ct36: 0,
  ct37: 0,
  ct38: 0,
  ct39a: 0,
  ct40: 0,
  ct40a: 0,
  ct40b: 0,
  ct41: 0,
  ct42: 0,
  ct43: 0,
};



// WEBPACK FOOTER //
// ./src/portal-components/value-added-tax/vat-return/vat-return-table/index.js